// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const IconAlertCircleRed: React.FunctionComponent<any> = ({ ...props }) => {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
            <g id="Shop-List-Item-Indicator">
                <g
                    id="Shop-List-Indicator-v1.01"
                    transform="translate(-1103.000000, -722.000000)"
                    stroke="#e33729"
                    fillOpacity="0"
                >
                    <g id="Bitmap-Copy-17" transform="translate(1087.000000, 204.000000)">
                        <g id="icon_alert_circle_24" transform="translate(16.000000, 518.000000)">
                            <circle
                                id="Oval"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                cx="12"
                                cy="12"
                                r="10"
                            ></circle>
                            <line
                                x1="12"
                                y1="8"
                                x2="12"
                                y2="12"
                                id="Path"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></line>
                            <line
                                x1="12"
                                y1="16"
                                x2="12.01"
                                y2="16"
                                id="Path"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></line>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
